(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reserve2', {
                parent: 'module',
                url: '/reserve2',
                params:{page: null},
                data: {
                    authorities: ['ROLE_MATERIAL_WAREHOUSE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/accessories/reserve/reserve.html',
                        controller: 'ReserveTwoController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();
